// frontend/src/pages/Dashboard/Admin/ManageComments.js

import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Bars3Icon, XMarkIcon } from '@heroicons/react/24/outline';
import axiosInstance from '../../../utils/axiosConfig';
import { Link } from 'react-router-dom';

const ManageComments = () => {
  const navigate = useNavigate();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const [comments, setComments] = useState([]);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  useEffect(() => {
    fetchComments();
  }, []);

  const fetchComments = async () => {
    try {
      const { data } = await axiosInstance.get('/admin/comments');
      setComments(data);
    } catch {
      setError('Fehler: Kommentare konnten nicht geladen werden.');
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Diesen Kommentar wirklich löschen?')) return;
    try {
      await axiosInstance.delete(`/admin/comments/${id}`);
      setSuccess('Kommentar gelöscht');
      fetchComments();
    } catch {
      setError('Fehler: Kommentar konnte nicht gelöscht werden.');
    }
  };

  const handleApprove = async (id, isApproved) => {
    try {
      await axiosInstance.put(`/admin/comments/${id}/approve`, { isApproved });
      setSuccess(`Kommentar ${isApproved ? 'freigegeben' : 'abgelehnt'}`);
      fetchComments();
    } catch {
      setError('Fehler: Kommentar konnte nicht aktualisiert werden.');
    }
  };

  return (
    <div className="flex min-h-screen">
      {/* SIDEBAR */}
      <div className={`${sidebarOpen ? 'block' : 'hidden'} sm:block bg-gray-100 w-64 p-4`}>
        {/* Close button (mobile) */}
        <button onClick={() => setSidebarOpen(false)} className="sm:hidden mb-4">
          <XMarkIcon className="w-6 h-6 text-gray-600" />
        </button>

        {/* Zurück-Button */}
        <button
          onClick={() => navigate(-1)}
          className="bg-primary text-white w-full text-left px-4 py-2 rounded hover:bg-orange-600 mb-2"
        >
          ← Zurück
        </button>

        {/* Admin Links */}
        <Link
          to="/admin/dashboard"
          className="block bg-primary text-white px-4 py-2 rounded hover:bg-orange-600 mb-2"
        >
          Admin-Dashboard
        </Link>
        <Link
          to="/admin/manage-articles"
          className="block bg-primary text-white px-4 py-2 rounded hover:bg-orange-600 mb-2"
        >
          Artikel verwalten
        </Link>
        <Link
          to="/admin/manage-users"
          className="block bg-primary text-white px-4 py-2 rounded hover:bg-orange-600 mb-2"
        >
          Benutzer verwalten
        </Link>
        <Link
          to="/admin/manage-comments"
          className="block bg-primary text-white px-4 py-2 rounded hover:bg-orange-600 mb-2"
        >
          Kommentare verwalten
        </Link>
        <Link
          to="/admin/manage-categories"
          className="block bg-primary text-white px-4 py-2 rounded hover:bg-orange-600"
        >
          Kategorien verwalten
        </Link>
      </div>

      {/* MAIN CONTENT */}
      <div className="flex-1 p-4">
        {/* Sidebar open (mobile) */}
        <button onClick={() => setSidebarOpen(true)} className="sm:hidden mb-4">
          <Bars3Icon className="w-6 h-6 text-gray-600" />
        </button>

        <motion.div className="py-8" initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
          <h1 className="text-3xl font-heading text-primary mb-6">
            Kommentare verwalten
          </h1>
          {error && <div className="bg-red-100 text-red-700 p-2 mb-4">{error}</div>}
          {success && <div className="bg-green-100 text-green-700 p-2 mb-4">{success}</div>}

          {comments.length === 0 ? (
            <p>Keine Kommentare gefunden.</p>
          ) : (
            <div className="overflow-x-auto">
              <table className="min-w-full bg-white text-center">
                <thead>
                  <tr>
                    <th className="border px-4 py-2">Artikel</th>
                    <th className="border px-4 py-2">Benutzer</th>
                    <th className="border px-4 py-2">Kommentar</th>
                    <th className="border px-4 py-2">Freigegeben</th>
                    <th className="border px-4 py-2">Aktionen</th>
                  </tr>
                </thead>
                <tbody>
                  {comments.map((c) => (
                    <tr key={c._id}>
                      <td className="border px-4 py-2">{c.article?.title}</td>
                      <td className="border px-4 py-2">{c.username}</td>
                      <td className="border px-4 py-2">{c.text}</td>
                      <td className="border px-4 py-2">{c.isApproved ? 'Ja' : 'Nein'}</td>
                      <td className="border px-4 py-2">
                        <button
                          onClick={() => handleApprove(c._id, !c.isApproved)}
                          className="bg-blue-500 text-white px-3 py-1 rounded mr-2"
                        >
                          {c.isApproved ? 'Ablehnen' : 'Freigeben'}
                        </button>
                        <button
                          onClick={() => handleDelete(c._id)}
                          className="bg-red-500 text-white px-3 py-1 rounded"
                        >
                          Löschen
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </motion.div>
      </div>
    </div>
  );
};

export default ManageComments;
